<template>
  <ul class="chat-widget__messages">
    <li
      v-for="(message, index) in allMessages"
      :key="index"
      :class="{
        'chat-widget__message--user': message.user,
        'chat-widget__message--other': !message.user,
      }"
    >
      <chat-message
        :message="message"
        :other-profile-image="otherProfileImage"
        :is-last-message="
          allMessages ? index === allMessages.length - 1 : false
        "
      />
    </li>
    <li v-if="isSending && !isStreaming" class="chat-widget__message--other">
      <div class="chat-widget__message-sender">
        <div class="chat-message-box">
          <img
            alt="Profile Image"
            class="chat-profile-image"
            :src="otherProfileImage"
          />
          <span
            class="chat-widget__message-bubble chat-widget__message-bubble--other"
          >
            <typing-indicator />
          </span>
        </div>
      </div>
    </li>
    <SuggestedActions />
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import TypingIndicator from './TypingIndicator.vue';
import ChatMessage from './ChatMessage.vue';
import SuggestedActions from './SuggestedActions.vue';
import { COPILOT_GETTERS } from '../../store/modules/copilot';

export default {
  name: 'ChatMessageList',
  components: {
    TypingIndicator,
    ChatMessage,
    SuggestedActions,
  },
  props: {
    allMessages: {
      type: Array,
      required: true,
    },
    isSending: {
      type: Boolean,
      required: true,
    },
    otherProfileImage: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('copilot', {
      isStreaming: COPILOT_GETTERS.isStreaming,
    }),
  },
};
</script>

<style lang="scss">
@import './ChatWidget.scss';
.chat-widget__messages {
  /* take up available space and allow scrolling */
  flex-grow: 1;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 10px;
}

.chat-widget__message--user {
  border-radius: 10px;
  padding: 10px;
  align-self: flex-end;
  background-color: $polly-light-blue;
  color: #fff;
  width: fit-content;
  margin-left: auto;
  margin-right: 0;
  max-width: 80%;
  margin-bottom: 10px;
}

.chat-widget__message--user:hover {
  background-color: $polly-light-blue;
}

.chat-widget__message--other {
  align-self: flex-start;
  margin-right: auto;
  margin-left: 0;
  width: fit-content;
  max-width: 90%;
  margin-bottom: 10px;
}

.chat-widget__message--other:hover {
  background-color: unset;
}
</style>
